import { Print } from "@mui/icons-material";
import { Box, Breadcrumbs, Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import api from '../../api';
import DidNotLoad from "../../components/DidNotLoad";
import Loading from "../../components/Loading";
import { quoteStatusLabel } from '../../helpers/quotes';
import QuoteForm from './QuoteForm';

function EditQuotePage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [quote, setQuote] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [didNotLoad, setDidNotLoad] = useState(false);

    useEffect(() => {
        if (!id) {
            return;
        }
        setIsLoading(true);
        setDidNotLoad(false);
        api.get(`quotes/${id}`)
            .then((response) => {
                setQuote(response.data.data || response.data);
            })
            .catch(() => {
                setDidNotLoad(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [id]);

    if (isLoading) {
        return <Loading />;
    }
    if (didNotLoad || !quote) {
        return <DidNotLoad />;
    }

    return (
        <div>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" onClick={() => navigate('/admin')} to="/admin">
                    Dashboard
                </Link>
                <Link color="inherit" onClick={() => navigate('/admin/quotes')} to="/admin/quotes">
                    Orçamentos
                </Link>
                <Typography color="text.primary">Editar orçamento</Typography>
            </Breadcrumbs>
            <br />
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 2,
                mb: 2,
            }}>
                <Typography variant="h4" gutterBottom sx={{ mb: 0 }}>
                    Editar orçamento
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Status: {quoteStatusLabel(quote.status)}
                    </Typography>
                    <Button
                        variant="outlined"
                        startIcon={<Print />}
                        onClick={() => window.open(`/admin/quotes/${id}/print`, '_blank')}
                    >
                        Imprimir
                    </Button>
                </Box>
            </Box>
            <QuoteForm mode="edit" quoteId={id} initialData={quote} />
        </div>
    );
}

export default EditQuotePage;
